import React, { FC, PropsWithChildren, createContext } from 'react';

import { DropDownMenuModeType } from './DropDownMenu.interface';

type ValueType = {
  mode: DropDownMenuModeType;
  closeSubMenu: () => void;
};

export const DropDownMenuContext = createContext<ValueType>({
  mode: 'light' as DropDownMenuModeType,
  closeSubMenu: () => {},
});

export const DropDownMenuProvider: FC<
  PropsWithChildren<{
    value: ValueType;
  }>
> = ({ children, value }) => {
  return <DropDownMenuContext.Provider value={value}>{children}</DropDownMenuContext.Provider>;
};
